import React, {useEffect, useState} from "react";
import "./style.scss";
import Eye from "../../../../assets/icons/eye-close-svgrepo-com.svg";
import EyeBlue from "../../../../assets/icons/eye-blue.svg";
import {ReactComponent as EditButton} from "../.../../../../../assets/newIcons/EditIcon.svg";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {returnErrors} from "../../../../store/reducers/error";
import {returnMessages} from "../../../../store/reducers/message";
import {baseUrl} from "../../../../utils/apis";
import {Spinner} from "phosphor-react";
import {deAuthenticate} from "../../../../store/reducers/authSlice";
import {PURGE_Brand} from "../../../../store/reducers/brandSlice";
import {clearPersistedData} from "../../../../store/configureStore";

function AccountPassword({handleLogout, handleSave}) {
  const [focusedInput, setFocusedInput] = useState(null);
  const [disabledInputs, setDisabledInputs] = useState(true);
  const [showPassword, setShowPassword] = useState({
    password: false,
    new_password: false,
    verifyPassword: false,
  });
  const [isSpinner, setIsSpinner] = useState(false);
  const [editMode, setEditMode] = useState(true);

  const [changePassword, setChangePassword] = useState({
    current_password: "",
    new_password: "",
  });

  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const handleFocus = (inputName) => setFocusedInput(inputName);
  const handleBlur = () => setFocusedInput(null);

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handlePasswordChange = (e) => {
    const {name, value} = e.target;
    setChangePassword((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditButton = () => {
    setDisabledInputs(false);
    setEditMode(false);
  };

  const handleChangePassword = async () => {
    if (!changePassword.current_password.trim() || !changePassword.new_password.trim() || !confirmNewPassword.trim()) {
      dispatch(returnErrors("Fields are empty", 400));
      return;
    }

    if (changePassword.new_password.trim() !== confirmNewPassword.trim()) {
      dispatch(returnErrors("Passwords do not match", 400));
      return;
    }

    setIsSpinner(true);

    try {
      const config = {
        headers: {Authorization: `Bearer ${idToken}`},
      };
      const res = await axios.post(`${baseUrl}/auth/settings/change-password/`, changePassword, config);

      if (res.data?.detail) {
        setShowPassword({
          password: false,
          new_password: false,
          verifyPassword: false,
        })
        setChangePassword({current_password: "", new_password: ""});
        setConfirmNewPassword("");  
        setDisabledInputs(true);
        setEditMode(true);
        // The backend ends every session on a password change, so sign out here too
        // and ask the user to log in with the new password
        dispatch(returnMessages("Password updated. Please log in with your new password.", 200));
        dispatch(deAuthenticate());
        dispatch(PURGE_Brand());
        await clearPersistedData();
        window.location.href = "/signin";
      } else {
        dispatch(returnErrors("Error updating password", 500));
      }
    } catch (error) {
      dispatch(returnErrors(error.response?.data?.detail || "Server error", 500));
    } finally {
      setIsSpinner(false);
      setShowPassword({
        password: false,
        new_password: false,
        verifyPassword: false,
      })
      setChangePassword({current_password: "", new_password: ""});
      setConfirmNewPassword("")
    }
  };

  return (
    <div className="account_password">
      <div className="account_password_input_container">
        <div className="headerSect">
          <h3 className="password_header">Password</h3>
          <div className="account_edit_img_wrapper">
            {editMode === true ? (
              <button
                className="editBtn"
                onClick={handleEditButton}
              >
                <EditButton />
                Edit Password
              </button>
            ) : (
              <button
                className="saveBtn"
                onClick={handleChangePassword}
              >
                {isSpinner ? <Spinner /> : <>Save </>}
              </button>
            )}
          </div>
        </div>

        <div className="wrapper_inputSection">
          <div className="account_input">
            <label
              className="labelSection"
              htmlFor="password"
            >
              Current Password
            </label>

            <div className="account_input_inner_wrapper">
              <div className={`password_conatiner ${!disabledInputs && "editable"}`}>
                <input
                  className={`account_password_input ${focusedInput === "password" ? "focused" : ""}`}
                  type={showPassword.password ? "text" : "password"}
                  name="current_password"
                  placeholder="Current Password"
                  id="password"
                  value={changePassword?.current_password}
                  onFocus={() => handleFocus("password")}
                  onBlur={handleBlur}
                  onChange={(e) => handlePasswordChange(e)}
                  disabled={disabledInputs}
                />
                <img
                  className={`eye_icon ${!disabledInputs ? " pointerCursor" : "defaultCursor"}`}
                  src={showPassword.password ? EyeBlue : Eye}
                  alt="eye icon"
                  onClick={() => {
                    if (!disabledInputs) {
                      togglePasswordVisibility("password");
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="account_input">
            <label
              className="labelSection"
              htmlFor="newPassword"
            >
              New Password
            </label>

            <div className="account_input_inner_wrapper">
              <div className={`password_conatiner ${!disabledInputs && "editable"}`}>
                <input
                  className={`account_password_input ${focusedInput === "new_password" ? "focused" : ""}`}
                  type={showPassword.new_password ? "text" : "password"}
                  value={changePassword?.new_password}
                  placeholder="New Password"
                  name="new_password"
                  id="new_password"
                  onFocus={() => handleFocus("new_password")}
                  onBlur={handleBlur}
                  onChange={(e) => handlePasswordChange(e)}
                  disabled={disabledInputs}
                />
                <img
                  className={`eye_icon ${!disabledInputs ? " pointerCursor" : "defaultCursor"}`}
                  src={showPassword.new_password ? EyeBlue : Eye}
                  alt="eye icon"
                  onClick={() => {
                    if (!disabledInputs) {
                      togglePasswordVisibility("new_password");
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="account_input">
            <label
              className="labelSection"
              htmlFor="verifyPassword"
            >
              Verify Password
            </label>

            <div className="account_input_inner_wrapper">
              <div className={`password_conatiner ${!disabledInputs && "editable"}`}>
                <input
                  className={`account_password_input ${focusedInput === "verifyPassword" ? "focused" : ""}`}
                  type={showPassword.verifyPassword ? "text" : "password"}
                  value={confirmNewPassword}
                  name="verifyPassword"
                  id="verifyPassword"
                  placeholder="Verify Password"
                  // value={confirmNewPassword}
                  onFocus={() => handleFocus("verifyPassword")}
                  onBlur={handleBlur}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  disabled={disabledInputs}
                />
                <img
                  className={`eye_icon ${!disabledInputs ? " pointerCursor" : "defaultCursor"}`}
                  src={showPassword.verifyPassword ? EyeBlue : Eye}
                  alt="eye icon"
                  onClick={() => {
                    if (!disabledInputs) {
                      togglePasswordVisibility("verifyPassword");
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-btn">
        <div className="action_btns">
          <button
            className="logout-btn"
            onClick={handleLogout}
          >
            Log Out
          </button>
        </div>
      </div>
      {/* <hr /> */}
    </div>
  );
}

export default AccountPassword;
